import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const Track = styled(Grid)(({ theme }) => ({
	width: '100%',
	height: '8px',
	borderRadius: '5px',
	backgroundColor: theme.palette.surface.main
}));

const Fill = styled(motion.div)(({ theme }) => ({
	height: 'inherit',
	borderRadius: 'inherit',
	backgroundColor: theme.palette.primary.main
}));

function LinearProgressBar({ value, animate = true, ...props }) {
	const normalize = (value) => {
		return `${Math.round(Math.min(100, Math.max(0, value)))}%`;
	};
	return (
		<Track {...props}>
			<Fill
				animate={{
					width: normalize(value)
				}}
				initial={{ width: animate ? 0 : normalize(value) }}
				transition={{
					ease: [0.77, 0, 0.175, 1],
					duration: animate ? 0.4 : 0
				}}
			/>
		</Track>
	);
}

export default LinearProgressBar;
